const state = () => ({
  selectednode:null,
  selectedconnection:null,
  nodes:[],
  connections:[],
  nodedragging:false,
  connectioncreated:false,
  fromnode:null,
  tonode:null,
  stagezoom:1,
  showsidebar:false,
  customattributes:[],
});
const getters = {
  selectednode(state){
    return state.selectednode
  },
  selectedconnection(state){
    return state.selectedconnection
  },
  nodes(state){
    return state.nodes
  },
  connections(state){
    return state.connections
  },
  nodedragging(state){
    return state.nodedragging
  },
  connectioncreated(state){
    return state.connectioncreated
  },
  fromnode(state){
    return state.fromnode
  },
  tonode(state){
    return state.tonode
  },
  stagezoom(state){
    return state.stagezoom
  },
  showsidebar(state){
    return state.showsidebar
  },
  customattributes(state){
    return state.customattributes
  },
};
const  mutations =  {
  SET_SELECTED_NODE(state,data){
    state.selectednode = data
  },
  SET_SELECTED_CONNECTION(state,data){
    state.selectedconnection = data
  },
  SET_NODES(state,data){
    state.nodes = data
  },
  SET_CONNECTIONS(state,data){
    state.connections = data
  },
  SET_NODE_DRAGGING(state,data){
    state.nodedragging = data
  },
  SET_CONNECTION_CREATED(state,data){
    state.connectioncreated = data
  },
  SET_FROM_NODE(state,data){
    state.fromnode = data
  },
  SET_TO_NODE(state,data){
    state.tonode = data
  },
  SET_STAGE_ZOOM(state,data){
    state.stagezoom = data
  },
  SET_SIDEBAR(state,data){
    state.showsidebar = data
  },
  SET_CUSTOMATTRIBUTES(state,data){
    state.customattributes = data
  },
};
const actions =  {
  setSelectedNode({commit},data)  {
    commit("SET_SELECTED_NODE",data)
  },
  setSelectedConnection({commit},data)  {
    commit("SET_SELECTED_CONNECTION",data)
  },
  setNodes({commit},data)  {
    commit("SET_NODES",data)
  },
  setConnections({commit},data)  {
    commit("SET_CONNECTIONS",data)
  },
  setNodeDragging({commit},data)  {
    commit("SET_NODE_DRAGGING",data)
  },
  setConnectionCreated({commit},data)  {
    commit("SET_CONNECTION_CREATED",data)
  },
  setFromNode({commit},data)  {
    commit("SET_FROM_NODE",data)
  },
  setToNode({commit},data)  {
    commit("SET_TO_NODE",data)
  },
  setStageZoom({commit},data)  {
    commit("SET_STAGE_ZOOM",data)
  },
  setSidebar({commit},data)  {
    commit("SET_SIDEBAR",data)
  },
  setCustomAttributes({commit},data)  {
    commit("SET_CUSTOMATTRIBUTES",data)
  },
}

export default {
  namespaced: true,
  mutations,
  getters,
  state,
  actions,
};

